export class IcdMapping {
    private id: string;
    private desc: string;

    constructor(icdMapping: any) {
        this.id = icdMapping.id;
        this.desc = icdMapping.desc;
    }

    /**
     * Getter $id
     * @return {string}
     */
    public get $id(): string {
        return this.id;
    }

    /**
     * Getter $desc
     * @return {string}
     */
    public get $desc(): string {
        return this.desc;
    }

    /**
     * Setter $id
     * @param {string} value
     */
    public set $id(value: string) {
        this.id = value;
    }

    /**
     * Setter $desc
     * @param {string} value
     */
    public set $desc(value: string) {
        this.desc = value;
    }

}

